// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2_PJa","notes":"Notes_notes__2cLk_","note":"Notes_note__1Dp8V","markdown":"Notes_markdown__1xUjj"};